__webpack_require__.p = "/reports-types-refactor-dashboards/account-setup/";